import { axisFont } from "../text/axisFont";
import { formatPrice } from "../axes/priceFormat";
import { PRICE_AXIS_PADDING_X_PX, PRICE_BADGE_ARROW_WIDTH_PX } from "../constants";
import { clampBadgeY } from "../overlays/priceBadge";
import { DRAWING_HANDLE_RADIUS_PX, DRAWING_HANDLE_RADIUS_TOUCH_PX } from "./drawingConstants";

const COARSE_POINTER_QUERY = "(pointer: coarse)";
const FULL_CIRCLE = 2 * Math.PI;

/**
 * Prices of horizontal lines on the price axis (po-chart-visual-spec.md §7.5):
 * only text in the colour of the line, in line with the axis labels; only while the price is in view.
 *
 * @param {object} textLayer
 * @param {object[]} shapes - from resolveShape
 * @param {object} params
 * @param {object} params.priceScale
 * @param {{ width: number, height: number }} params.pane
 * @param {number} params.decimals - price precision of the pair
 * @param {string} params.fontFamily
 */
export const drawDrawingPrices = (textLayer, shapes, { priceScale, pane, decimals, fontFamily }) => {
  const font = axisFont(fontFamily);
  const x = pane.width + PRICE_BADGE_ARROW_WIDTH_PX + PRICE_AXIS_PADDING_X_PX;

  shapes.forEach(({ item, tool }) => {
    if (!tool.hasPriceLabel) return;

    const { price } = item.points[0];
    const y = priceScale.priceToY(price);

    if (!(y >= 0 && y <= pane.height)) return;

    textLayer.drawText(formatPrice(price, decimals), x, clampBadgeY(y, pane), { font, color: item.style.color, align: "left" });
  });
};

/**
 * Handles of the drawings: white circles on their points, always shown
 * (po-chart-visual-spec.md §7.5), bigger on touch screens (E16), never over the other panes.
 *
 * @param {object} textLayer
 * @param {object[]} shapes - from resolveShape
 * @param {{ width: number, height: number }} pane
 * @param {string} color - CSS colour
 */
export const drawDrawingHandles = ({ context }, shapes, pane, color) => {
  if (!shapes.length) return;

  const radius = window.matchMedia(COARSE_POINTER_QUERY).matches
    ? DRAWING_HANDLE_RADIUS_TOUCH_PX
    : DRAWING_HANDLE_RADIUS_PX;

  context.save();
  context.beginPath();
  context.rect(0, 0, pane.width, pane.height);
  context.clip();
  context.fillStyle = color;
  context.beginPath();
  shapes.forEach(({ handles }) =>
    handles.forEach(({ x, y }) => {
      context.moveTo(x + radius, y);
      context.arc(x, y, radius, 0, FULL_CIRCLE);
    }),
  );
  context.fill();
  context.restore();
};
